<template>
    <section class="main-content is-transparent">
        <div class="hero">
            <div class="hero-body">
                <h1
                    class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
                >
                    {{ $t("cookies.title") }}
                </h1>
                <p><strong>Ultimo aggiornamento 01 luglio 2023</strong></p>
                <p>
                    La presente Cookie Policy spiega come Nuovo Rinascimento APS
                    ("<b>noi</b>" e "<b>nostro</b>") utilizza cookie e
                    tecnologie simili per riconoscerti quando visiti il nostro
                    sito Web
                    <a target="_blank" href="https://www.tempiodelfuturo.art"
                        >www.tempiodelfuturo.art</a
                    >
                    ("<b>Sito Web</b>"). Spiega cosa queste tecnologie sono e
                    perché le utilizziamo, così come i tuoi diritti per
                    controllarne l'utilizzo.
                </p>
                <p>
                    In alcuni casi potremmo utilizzare i cookie per raccogliere
                    dati personali, o che diventano informazioni personali se
                    combinate con altre informazioni.
                </p>
                <p><strong>Cosa sono i cookie?</strong></p>
                <p>
                    I cookie sono piccoli file di dati che vengono inseriti sul
                    tuo computer o dispositivo mobile quando si visita un sito
                    web. I cookie sono ampiamente utilizzati dai proprietari di
                    siti Web al fine di far funzionare i loro siti Web, o per
                    lavorare in modo più efficiente, nonché per fornire report
                    informazione.
                </p>
                <p>
                    I cookie impostati dal titolare del sito web (in questo
                    caso, Nuovo Rinascimento APS) sono chiamati "Cookie
                    proprietari." Cookie impostati da soggetti diversi dal I
                    proprietari del sito web sono chiamati "cookie di terze
                    parti". Terze parti I cookie consentono alle caratteristiche
                    o funzionalità di terze parti di essere forniti su o
                    attraverso il sito Web (ad esempio, pubblicità, contenuti
                    interattivi e analisi). Le parti che stabiliscono Questi
                    cookie di terze parti possono riconoscere sia il tuo
                    computer quando visita il sito web in questione e anche
                    quando visita alcuni altri siti web.
                </p>
                <p><strong>Perché utilizziamo i cookie?</strong></p>
                <p>
                    Usiamo prima e terze parti cookie per diversi motivi. Alcuni
                    cookie sono necessari per motivi tecnici per il
                    funzionamento del nostro sito Web, e noi Fare riferimento a
                    questi come cookie "essenziali" o "strettamente necessari".
                    Altri cookie ci consentono anche di tracciare e indirizzare
                    gli interessi dei nostri utenti per migliorare l'esperienza
                    sul nostro Online Proprietà. Terzi servire i cookie
                    attraverso il nostro sito Web per pubblicità, analisi, e
                    altri scopi. Questo è descritto più dettagliatamente di
                    seguito.
                </p>
                <p><strong>Come posso controllare i cookie?</strong></p>
                <p>
                    Hai il diritto di decidere se accettare o rifiutare
                    Biscotti. Puoi esercitare i tuoi diritti sui cookie
                    impostando il tuo preferenze nel Cookie Consent Manager. Il
                    consenso ai cookie Manager ti consente di selezionare quali
                    categorie di cookie accettare o rifiutare. I cookie
                    essenziali non possono essere rifiutati in quanto sono
                    strettamente necessari per fornirti i servizi.
                </p>
                <p>
                    Il Cookie Consent Manager è disponibile nella notifica
                    banner e sul nostro sito web. Se si sceglie di rifiutare i
                    cookie, È ancora possibile utilizzare il nostro sito Web
                    attraverso l'accesso ad alcuni La funzionalità e le aree del
                    nostro sito Web possono essere limitate. Tu può anche
                    impostare o modificare i controlli del browser Web per
                    accettare o rifiutare i cookie.
                </p>
                <p>
                    I tipi specifici di cookie proprietari e di terze parti
                    serviti attraverso il nostro sito Web e le finalità che
                    svolgono sono descritto nella tabella seguente (si prega di
                    notare che il i cookie specifici serviti possono variare a
                    seconda dello specifico Online Proprietà visitate):<strong
                        >Cookie essenziali del sito web:</strong
                    >
                </p>
                <p>
                    Questi cookie sono strettamente necessari per fornirti
                    servizi disponibili attraverso il nostro sito Web e per
                    utilizzare alcuni dei le sue caratteristiche, come l'accesso
                    alle aree sicure.
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>i18n_redirected</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>
                                Cookie di reindirizzamento per
                                internazionalizzazione
                            </td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>www.tempiodelfuturo.art</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>server_cookie</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>11 mesi 30 giorni</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>authrefToken</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Autenticazione</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>www.tempiodelfuturo.art</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>13 giorni</td>
                        </tr>
                    </tbody>
                </table>
                <p><strong>Cookie di performance e funzionalità:</strong></p>
                <p>
                    Questi cookie sono utilizzati per migliorare le prestazioni
                    e funzionalità del nostro sito Web, ma non sono essenziali
                    per la loro usare. Tuttavia, senza questi cookie, alcune
                    funzionalità (come i video) potrebbe non essere disponibile.
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>__hubs_finished_tips</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mozilla Hubs</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>hubs.mozilla.com</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mozilla.org/en-US/privacy/hubs/#:~:text=Who%20Hubs%20May%20Disclose%20Information,add%20to%20a%20Hubs%20room."
                                    >Visualizza l'informativa sulla privacy del
                                    servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Stati Uniti</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>mapbox.eventData.uuid:Z2RpY3I=</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mapbox</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>www.tempiodelfuturo.art</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mapbox.com/legal/privacy"
                                    >Informativa sulla privacy del servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Irlanda</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>mapbox.eventData:Z2RpY3I=</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mapbox</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>www.tempiodelfuturo.art</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mapbox.com/legal/privacy"
                                    >Informativa sulla privacy del servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Irlanda</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>Debug</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mozilla Hubs</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>hubs.mozilla.com</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mozilla.org/en-US/privacy/hubs/#:~:text=Who%20Hubs%20May%20Disclose%20Information,add%20to%20a%20Hubs%20room."
                                    >Visualizza l'informativa sulla privacy del
                                    servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Stati Uniti</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>___concurrent_load_detector_global</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mozilla Hubs</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>hubs.mozilla.com</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mozilla.org/en-US/privacy/hubs/#:~:text=Who%20Hubs%20May%20Disclose%20Information,add%20to%20a%20Hubs%20room."
                                    >Visualizza l'informativa sulla privacy del
                                    servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Stati Uniti</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>___hubs_store</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>Mozilla Hubs</td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>hubs.mozilla.com</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://www.mozilla.org/en-US/privacy/hubs/#:~:text=Who%20Hubs%20May%20Disclose%20Information,add%20to%20a%20Hubs%20room."
                                    >Visualizza l'informativa sulla privacy del
                                    servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Stati Uniti</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>html_local_storage</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>persistente</td>
                        </tr>
                    </tbody>
                </table>
                <p><strong>Cookie analitici e di personalizzazione:</strong></p>
                <p>
                    Questi cookie raccolgono informazioni che vengono utilizzate
                    sia in forma aggregata per aiutarci a capire come il nostro
                    Sito Web viene utilizzato o quanto sono efficaci le nostre
                    campagne di marketing, o per aiutarci a personalizzare il
                    nostro Sito Web per te.
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>Nome:</td>
                            <td>_ga_#</td>
                        </tr>
                        <tr>
                            <td>Scopo:</td>
                            <td>
                                Utilizzato per distinguere i singoli utenti
                                mediante designazione di un numero generato
                                casualmente come identificatore client, che
                                consente il calcolo di Visite e sessioni
                            </td>
                        </tr>
                        <tr>
                            <td>Provider:</td>
                            <td>analytics.google.com</td>
                        </tr>
                        <tr>
                            <td>Servizio:</td>
                            <td>
                                <a
                                    target="_blank"
                                    href="https://policies.google.com/privacy"
                                    >Visualizza l'informativa sulla privacy del
                                    servizio</a
                                >
                            </td>
                        </tr>
                        <tr>
                            <td>Paese:</td>
                            <td>Stati Uniti</td>
                        </tr>
                        <tr>
                            <td>Tipo:</td>
                            <td>http_cookie</td>
                        </tr>
                        <tr>
                            <td>Scadenza:</td>
                            <td>1 anno 1 mese 4 giorni</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <strong
                        >Come posso controllare i cookie sul mio
                        browser?</strong
                    >
                </p>
                <p>
                    Come mezzo con cui puoi rifiutare i cookie attraverso il tuo
                    web I controlli del browser variano da browser a browser,
                    dovresti visitare Il menu di aiuto del browser per ulteriori
                    informazioni. Quanto segue è Informativa su come gestire i
                    cookie sui più diffusi Browser:
                </p>
                <ul>
                    <li>
                        <a
                            href="https://support.google.com/chrome/answer/95647#zippy=%2Callow-or-block-cookies"
                            >Chrome</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
                            >Internet Explorer</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectslug=enable-and-disable-cookies-website-preferences&amp;redirectlocale=en-US"
                            >Firefox</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://support.apple.com/en-ie/guide/safari/sfri11471/mac"
                            >Safari</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://support.microsoft.com/en-us/windows/microsoft-edge-browsing-data-and-privacy-bb8174ba-9d73-dcf2-9b4a-c582b4e640dd"
                            >Edge</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://help.opera.com/en/latest/web-preferences/"
                            >Opera</a
                        >
                    </li>
                </ul>
                <p>
                    Inoltre, la maggior parte delle reti pubblicitarie ti offre
                    un modo per rinunciare di pubblicità mirata. Se vuoi saperne
                    di più Informazioni, visitare:
                </p>
                <ul>
                    <li>
                        <a
                            target="_blank"
                            href="http://www.aboutads.info/choices/"
                            >Alleanza per la pubblicità digitale</a
                        >
                    </li>
                    <li>
                        <a target="_blank" href="https://youradchoices.ca/"
                            >Digital Advertising Alliance of Canada</a
                        >
                    </li>
                    <li>
                        <a
                            target="_blank"
                            href="http://www.youronlinechoices.com/"
                            >Alleanza europea per la pubblicità digitale
                            interattiva</a
                        >
                    </li>
                </ul>
                <p>
                    <strong
                        >Che dire di altre tecnologie di tracciamento, come il
                        web Beacon?</strong
                    >
                </p>
                <p>
                    I cookie non sono l'unico modo per riconoscere o tracciare i
                    visitatori di un sito web. Possiamo usare Altre tecnologie
                    simili di volta in volta, come il web beacon (a volte
                    chiamati "pixel di tracciamento" o "clear" gif"). Si tratta
                    di piccoli file grafici che contengono un unico
                    identificatore che ci consente di riconoscere quando
                    qualcuno ha visitato il nostro sito Web o ha aperto
                    un'e-mail includendoli. Questo ci consente, ad esempio, di
                    monitorare i modelli di traffico degli utenti da una pagina
                    all'interno di un sito web a un altro, per consegnare o
                    comunicare con cookie, per capire se sei arrivato al sito
                    web da un annuncio online visualizzato su un sito web di
                    terze parti, per migliorare le prestazioni del sito e per
                    Misurare il successo delle campagne di email marketing. In
                    In molti casi, queste tecnologie dipendono cookie per
                    funzionare correttamente, e quindi rifiutare i cookie
                    comprometterà il loro funzionamento.
                </p>
                <p>
                    <strong
                        >Utilizzate cookie Flash o Local Shared Objects?</strong
                    >
                </p>
                <p>
                    I siti web possono anche utilizzare i cosiddetti "Flash
                    Cookie" (noti anche come Local Shared Objects o "LSO") per,
                    tra le altre cose, raccogliere e memorizzare informazioni
                    sull'utilizzo dei nostri servizi, frodi prevenzione e per
                    altre operazioni del sito.
                </p>
                <p>
                    Se non si desidera che i cookie Flash vengano memorizzati
                    sul computer, si può regolare le impostazioni del tuo Flash
                    player per bloccare Flash Memorizzazione dei cookie
                    utilizzando gli strumenti contenuti nel
                    <a
                        href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                        >pannello delle impostazioni di archiviazione del sito
                        web</a
                    >. Puoi anche controllare i cookie Flash andando su il
                    <a
                        href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html"
                        >pannello Impostazioni globali di archiviazione</a
                    >
                    e seguendo le istruzioni (che possono includere istruzioni
                    che spiegano, ad esempio, come eliminare Flash esistenti
                    Cookie (riferiti alle "informazioni" presenti sul sito
                    Macromedia), come impedire che Flash LSO vengano inseriti
                    nel computer senza che ti venga chiesto, e (per Flash Player
                    8 e versioni successive) come bloccare i cookie Flash che
                    non vengono forniti dal operatore della pagina in cui ti
                    trovi in quel momento).
                </p>
                <p>
                    Si noti che l'impostazione di Flash Player per limitare o
                    limitare l'accettazione dei Flash Cookie può ridurre o
                    impedire il funzionalità di alcune applicazioni Flash, tra
                    cui, potenzialmente, le applicazioni Flash utilizzate in
                    connessione con il nostro servizi o contenuti online.
                </p>
                <p><strong>Offrite pubblicità mirata?</strong></p>
                <p>
                    Terze parti possono servire cookie sul tuo computer o
                    cellulare dispositivo per pubblicare pubblicità attraverso
                    il nostro sito Web. Queste aziende può utilizzare le
                    informazioni sulle tue visite a questo e altri siti Web al
                    fine di fornire pubblicità pertinenti sui prodotti e servizi
                    che potrebbero interessarti. Possono anche impiegare
                    tecnologia utilizzata per misurare l'efficacia di
                    Pubblicità. Possono farlo utilizzando i cookie o il web
                    beacon per raccogliere informazioni sulle tue visite a
                    questo e altri siti al fine di fornire annunci pubblicitari
                    pertinenti su beni e servizi di potenziale interesse per
                    l'utente. Le informazioni raccolti attraverso questo
                    processo non consentono a noi o a loro di identificare il
                    tuo nome, i dettagli di contatto o altri dettagli che
                    identificarti direttamente, a meno che tu non scelga di
                    fornirli.
                </p>
                <p>
                    <strong
                        >Con quale frequenza aggiornerai la presente Informativa
                        sui cookie?</strong
                    >
                </p>
                <p>
                    Potremmo aggiornare la presente Informativa sui cookie di
                    volta in volta al fine di riflettere, Ad esempio, modifiche
                    ai cookie che utilizziamo o per altri motivi operativi,
                    legali o normativi. Si prega quindi di rivisitare
                    regolarmente la presente Informativa sui cookie per rimanere
                    informati su il nostro utilizzo dei cookie e delle
                    tecnologie correlate.
                </p>
                <p>
                    La data nella parte superiore della presente Cookie Policy
                    indica quando è stato aggiornato l'ultima volta.
                </p>
                <p>
                    <strong>Dove posso trovare ulteriori informazioni?</strong>
                </p>
                <p>
                    In caso di domande sul nostro utilizzo di cookie o altri
                    tecnologie, vi preghiamo di inviarci un'e-mail all'indirizzo
                    amm.nuovorinascimentoitaliano@gmail.com o per posta a:
                </p>
                <p>Nuovo Rinascimento APS</p>
                <p>Via Luigi Nono, 7, 20154 Milano MI, Italy</p>
                <p>Milano, Lombardia 20154</p>
                <p>Italia</p>
                <p>Telefono: (+39)3917700315</p>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero {
    > * {
        color: var(--color-subtle) !important;
    }
}
.hero-body {
    @media screen and (max-width: 768px) {
        max-width: 95vw;
    }
    // padding: 0 1rem;
}

// table styling

table {
    word-break: break-word;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 1rem;
    width: 100%;
    border: 1px solid var(--color-primary-alt);
    th,
    td {
        // first child
        &:first-child {
            width: 10rem;
        }
        text-align: left;
        padding: 0.5rem;
        border: 1px solid var(--color-primary-alt);
    }
    th {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(even) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(odd) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
}
p > strong,
li > strong {
    color: var(--color-primary-alt);
    font-weight: 700;
    font-size: 1.2rem;
}
p {
    margin-bottom: 1rem;
}
p > strong {
    display: block;
    // display: inline !important;
}
a {
    color: var(--color-primary) !important;
    // text-decoration: underline;
    text-transform: uppercase;
    font-weight: 700;
    margin: 0 0.25rem;
    display: inline !important;
}
// list styling

ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;
    // margin-bottom: 1rem;
    li {
        margin-left: 0;
        margin-bottom: 1rem;
        &:before {
            content: "•";
            color: var(--color-primary-alt);
            display: inline-block;
            width: 1rem;
            margin-left: 1rem;
        }
    }
}
</style>
<script>
export default {
    name: "CookiePolicy",
    data() {
        return {
            pageTitle: "TDF*P — " + this.$t("cookies.meta.title"),
            height: "100%",
        };
    },
    layout: "default",

    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("cookies.title"));
        if (this.$i18n.locale === "en") {
            //redirecet to privacy-en
            this.$router.push("/en/cookies-en");
        }
        this.enterAnimation();
        // load termly embed script
    },
    head() {
        return {
            title: this.pageTitle,
        };
    },
    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("cookies.title"));
        },
    },

    methods: {
        enterAnimation() {
            const anime = this.$anime;
            anime({
                targets: ".main-content",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
